import { Component, OnInit } from '@angular/core';
import { notDesktop } from '@libraries/ui-state';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { CloseActive } from '../../state';

@Component({
  selector: 'may-be-eligible',
  templateUrl: './may-be-eligible.component.html',
  styleUrls: ['./may-be-eligible.component.scss'],
  standalone: false,
})
export class MayBeEligibleComponent implements OnInit {
  private notDesktop$ = this.store.select(notDesktop);

  constructor(private store: Store) {}

  ngOnInit() {
    this.notDesktop$
      .pipe(
        take(1),
        filter((nonDesktop) => nonDesktop)
      )
      .subscribe(() => window.scrollTo(0, 0));
  }

  onClose() {
    this.store.dispatch(CloseActive());
  }
}
